import { BaseFetch } from "../main-model"
export default class ScheduleModel extends BaseFetch {
  getScheduleBy = (data) =>
    this.authFetch({
      url: "schedule/getScheduleBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getScheduleById = (data) =>
    this.authFetch({
      url: "schedule/getScheduleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateScheduleById = (data) =>
    this.authFetch({
      url: "schedule/updateScheduleById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSchedule = (data) =>
    this.authFetch({
      url: "schedule/insertSchedule",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteScheduleById = (data) =>
    this.authFetch({
      url: "schedule/deleteScheduleById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
